var template = require('../templates/ErrorMobile.html');

module.exports = Backbone.View.extend({
    el: '.content',

    initialize: function() {
        this.render();
    },

    render: function() {
        this.$el.html(template());
        $('body').addClass('gray-bg');
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/ErrorMobile.js